import React, { useState } from 'react';

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";


import ErrorPage from "./Components/pages/Error/Error";
import Accueil from "./Components/pages/Accueil/Accueil";
import Présentation from "./Components/pages/Présentation/Présentation";


import Contact from './Components/pages/Contact/Contact';
import References from './Components/pages/References/References';
import ScrollToTopRender from "./Components/Shared/ScrollToTop_render";
import Produits from './Components/pages/Produits/Produits';
import ProductDetails from './Components/pages/Produits/Product_Details/ProductDetails'
import PoissonDetails from './Components/pages/Produits/Product_Details/PoissonDetails';
import CharcuterieDetails from './Components/pages/Produits/Product_Details/CharcuterieDetails';
import FruitsDetails from './Components/pages/Produits/Product_Details/FruitsDetails';
import OeufsDetails from './Components/pages/Produits/Product_Details/OeufsDetails';
import DattesDetails from './Components/pages/Produits/Product_Details/DattesDetails';


import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
function App() {

  const [lang, SetLang] = useState('fr');

  return (
    <div className="App">
      <Router>
        <ScrollToTopRender />
        <I18nextProvider i18n={i18next}>
          <Switch>
            <Route exact path="/"  >
              <Accueil lang={lang} SetLang={SetLang} />
            </Route>

            <Route path="/presentation"  >
              <Présentation lang={lang} SetLang={SetLang} />
            </Route>
            <Route path={"/reference"} >
              <References lang={lang} SetLang={SetLang} />
            </Route>

            <Route exact path={"/Produits"}  >
              <Produits lang={lang} SetLang={SetLang} />
            </Route>
            <Route path={"/contact"}  >
              <Contact lang={lang} SetLang={SetLang} />
            </Route>

            <Route path={"/Produits/viande"}  >
              <ProductDetails lang={lang} SetLang={SetLang} />
            </Route>

            <Route path={"/Produits/poisson"}  >
              <PoissonDetails lang={lang} SetLang={SetLang} />
            </Route>
            <Route path={"/Produits/charcuterie"}  >
              <CharcuterieDetails lang={lang} SetLang={SetLang} />
            </Route>
            <Route path={"/Produits/fruits"}  >
              <FruitsDetails lang={lang} SetLang={SetLang} />
            </Route>
            <Route path={"/Produits/oeufs"} >
              <OeufsDetails lang={lang} SetLang={SetLang} />
            </Route>
            <Route path={"/Produits/dattes"}  >
              <DattesDetails lang={lang} SetLang={SetLang} />
            </Route>

            <Route component={ErrorPage} />

          </Switch>
        </I18nextProvider>


      </Router>

    </div>
  );
}

export default App;


